import React, {useEffect, useState} from 'react'

import StockList from "../../components/StockList/StockList";
import SearchField from "../../components/SearchField/SearchField";
import Spacer from "../../components/Spacer";
import DropdownFIlter from "../../components/FIlter/DropdownFIlter";
import {useParams} from "react-router-dom";

const StockListScreen = ({isIndexListScreen, isCryptoListScreen}) => {
    const {countryName} = useParams()

    const [searchText, setSearchText] = useState('')
    const [searchSector, setSearchSector] = useState('')
    const [scrollLock, setScrollLock] = useState(false)

    useEffect(() => {
        setSearchText('')
        setSearchSector('')
    }, [countryName])

    const handleSearchInputChange = (e) => {
        setSearchText(e.target.value)
        setScrollLock(false)
        /* const filteredStocks = data.allStocks.filter(sto => {
             if (e.target.value === '') return fetchedStockList
             return (sto.fullName.toLowerCase().includes(e.target.value.toLowerCase()) || sto.ticker.ticker.toLowerCase().includes(e.target.value.toLowerCase()))
             //return (sto.ticker.toLowerCase().includes(e.target.value.toLowerCase()))
         })
         setFetchedStockList(filteredStocks)*/

    }

    return (
        <>
            <div>
                <Spacer size={25}/>
                <div style={{margin: '15px'}}>
                    <SearchField onChange={handleSearchInputChange} searchText={searchText}
                                 isIndexListScreen={isIndexListScreen} isCryptoListScreen={isCryptoListScreen}/>
                    <Spacer size={15}/>
                    <DropdownFIlter searchFilterString={searchSector} setSearchFilterString={setSearchSector}
                                    setScrollLock={setScrollLock}/>
                    <Spacer size={15}/>
                </div>
                <StockList searchText={searchText} searchSector={searchSector} scrollLock={scrollLock}
                           setScrollLock={setScrollLock} isIndexListScreen={isIndexListScreen}
                           isCryptoListScreen={isCryptoListScreen}/>
            </div>
        </>


    )
}

export default StockListScreen